<template>
    <section class="bg-black overflow-hidden relative at1024:h-[1070px]">
        <div
            class="pb-[68px] pt-[90px] px-4 relative text-center z-20 at1024:pb-[380px] at1024:pt-[180px]"
        >
            <h1
                class="font-bold leading-none mb-7 text-[40px] text-white at1024:max-w-[830px] at1024:mx-auto at1024:text-[80px]"
            >
                We understand the needs of Locksmiths.
            </h1>
            <p
                class="leading-tight mb-7 text-gray-300 text-lg at1024:max-w-[742px] at1024:mx-auto at1024:text-[23px]"
            >
                Staying on top of the latest offerings in electronic products,
                having access to every mechanical product you might need, and
                getting it all shipped out the same day? You’re on the right
                path with SECLOCK.
            </p>
            <div class="gap-7 flex flex-col items-center">
                <a href="/contact" class="btn-white-on-red"
                    >Get in touch today</a
                >
                <a
                    href="#segment-go"
                    class="font-medium text-white tracking-widest underline uppercase hover:text-red"
                    >Learn more</a
                >
            </div>
        </div>
        <div
            class="hidden absolute bottom-0 left-1/2 -translate-x-1/2 z-10 w-[1390px] at1024:block"
        >
            <img
                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/segments_header_l"
                height="709"
                width="1390"
                sizes="1390px"
                loading="lazy"
                alt=""
                aria-hidden="true"
            />
        </div>
    </section>
    <div class="bg-gradient-to-b from-black to-gray-800">
        <section
            id="segment-go"
            class="pb-[96px] pt-[60px] px-4 at1024:pt-[90px] at1024:px-8"
        >
            <h2
                class="font-bold leading-none mb-[30px] text-[40px] text-center text-white at1024:max-w-4xl at1024:mx-auto at1024:text-[80px]"
            >
                The SECLOCK Difference<span class="sr-only">:</span>
                <span class="block text-gray-400"
                    >You’re on the Path to Everything You Need</span
                >
            </h2>
            <p class="text-center text-gray-400 text-lg">
                Wholesale-Only Distributor Dedicated to Serving the Trade:
            </p>
            <ul
                class="gap-9 flex flex-col max-w-[630px] mt-20 mx-auto text-lg at1024:grid at1024:grid-cols-2 at1024:max-w-[1060px] at1024:mt-[120px] at1024:text-[23px]"
            >
                <li>
                    <BaseSvg
                        name="icon-cube-box"
                        aria-hidden="true"
                        class="h-[60px] mb-1 text-gray w-[60px]"
                    />
                    <h3 class="font-bold mb-[10px] text-white">
                        Our warehouse is yours
                    </h3>
                    <p class="text-gray-300">
                        We give you access to the largest selection of
                        electric/mechanical door hardware and accessories in the
                        industry, saving you the need of holding onto inventory.
                    </p>
                </li>
                <li>
                    <BaseSvg
                        name="icon-support-phone"
                        aria-hidden="true"
                        class="h-[60px] mb-1 text-gray w-[60px]"
                    />
                    <h3 class="font-bold mb-[10px] text-white">
                        Factory-trained experts
                    </h3>
                    <p class="text-gray-300">
                        Our technical service reps are the best in the business
                        and they’re available as a resource for you. Call, chat
                        or text us and they can answer any questions.
                    </p>
                </li>
                <li>
                    <BaseSvg
                        name="icon-shipping-truck"
                        aria-hidden="true"
                        class="h-[60px] mb-1 text-gray w-[60px]"
                    />
                    <h3 class="font-bold mb-[10px] text-white">
                        We ship the same-day
                    </h3>
                    <p class="text-gray-300">
                        When you need it most, we have it in-stock and you can
                        depend on same-day shipping from the industry’s most
                        comprehensive inventory.
                    </p>
                </li>
                <li>
                    <BaseSvg
                        name="icon-developer-board"
                        aria-hidden="true"
                        class="h-[60px] mb-1 text-gray w-[60px]"
                    />
                    <h3 class="font-bold mb-[10px] text-white">
                        A dedicated parts department
                    </h3>
                    <p class="text-gray-300">
                        We can get you any component you might require, no
                        matter the difficulty. With SECLOCK, we're your one-stop
                        shop.
                    </p>
                </li>
            </ul>
        </section>
        <section class="overflow-hidden relative">
            <div
                class="pb-56 pt-10 px-4 relative text-center z-20 at1024:pb-[345px] at1024:pt-[180px]"
            >
                <h2
                    class="font-bold leading-none mb-7 text-[30px] text-white at1024:max-w-[830px] at1024:mx-auto at1024:text-5xl"
                >
                    We stock products from over one hundred top manufacturers.
                </h2>
                <a href="/catalog/manufacturers" class="btn-white-on-red"
                    >Browse<span class="sr-only"> manufacturers</span></a
                >
            </div>
            <div
                class="absolute bottom-0 left-1/2 -translate-x-1/2 w-[850px] z-10 at1024:w-[1400px]"
            >
                <img
                    src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/segments_mid_l"
                    height="701"
                    width="1400"
                    sizes="1400px"
                    loading="lazy"
                    alt=""
                    aria-hidden="true"
                />
            </div>
        </section>
        <section
            class="overflow-hidden pb-[90px] pt-44 at1024:flex at1024:pb-56 at1024:relative"
        >
            <div
                class="mb-20 translate-x-8 w-[662px] at1024:absolute at1024:left-[38%] at1024:mb-0 at1024:order-2 at1024:w-[1344px] at1024:z-10 at1440:left-[39%]"
            >
                <img
                    src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/about_val_laptop"
                    height="777"
                    width="1344"
                    sizes="1344px"
                    loading="lazy"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <div
                class="max-w-3xl mx-auto px-4 at1024:max-w-none at1024:order-1 at1024:px-8 at1024:relative at1024:w-[1464px] at1024:z-20"
            >
                <div class="at1024:max-w-[475px]">
                    <h2
                        class="font-bold leading-none mb-[30px] text-[40px] text-white at1024:pt-[132px] at1024:text-[80px]"
                    >
                        SECLOCK.com
                        <span class="text-gray-400">— It’s all here.</span>
                    </h2>
                    <p
                        class="font-bold leading-[1.2] text-[28px] text-gray-400 at1024:text-[35px]"
                    >
                        We built SECLOCK.com to help locksmith professionals get
                        the job done right every time. And our experts are also
                        always available to provide assistance via chat, phone
                        or email. See how our site acts as a resource and guide,
                        and puts you on the path.
                    </p>
                </div>
            </div>
        </section>
    </div>
    <section
        class="overflow-hidden pb-9 pt-[60px] at1024:flex at1024:pb-56 at1024:relative"
        style="
            background-image: linear-gradient(
                rgb(37, 40, 42),
                rgb(84, 87, 89) 40%,
                rgb(125, 128, 131) 60%,
                rgb(153, 155, 157) 70%,
                rgb(215, 215, 216) 85%,
                rgb(255, 255, 255)
            );
        "
    >
        <div
            class="max-w-[400px] mx-auto mb-9 at1024:absolute at1024:bottom-0 at1024:left-[45%] at1024:max-w-none at1024:mb-0 at1024:order-2 at1024:w-[1089px] at1024:z-10"
        >
            <img
                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/segments_footer"
                height="637"
                width="1089"
                sizes="1089px"
                loading="lazy"
                alt=""
                aria-hidden="true"
            />
        </div>
        <div
            class="max-w-3xl mx-auto px-4 at1024:max-w-none at1024:order-1 at1024:px-8 at1024:relative at1024:w-[1464px] at1024:z-20"
        >
            <div class="text-center text-white at1024:w-2/5 at1024:text-left">
                <h2
                    class="font-bold leading-[1.1] mb-4 text-2xl at1024:leading-[1.15] at1024:pt-[90px] at1024:text-5xl"
                >
                    Meet Your Dedicated Locksmith Experts
                </h2>
                <p class="leading-snug mb-9 text-xl at1024:text-xl">
                    <q
                        >When you need it most, we have it in-stock – and you
                        can depend on same-day shipping from the industry’s most
                        comprehensive inventory.</q
                    >
                </p>
                <a href="/contact" class="btn-white-on-blue">Contact us</a>
            </div>
        </div>
    </section>
    <section class="px-4 py-[60px] text-center at1024:px-8 at1024:py-[90px] dark:bg-white">
        <h2
            class="font-bold leading-[1.1] mb-4 max-w-[1060px] mx-auto text-2xl at1024:text-5xl dark:text-black"
        >
            What our Locksmith Professional customers say:
        </h2>
        <p
            class="font-bold mb-6 text-gray text-lg at768:mb-16 at1024:text-[23px]"
        >
            Don’t just take our word for it…
        </p>
        <Splide
            aria-label="Testimonials"
            class="text-gray text-[28px] at1024:text-[35px]"
            :options="{
                arrows: false,
            }"
        >
            <SplideSlide>
                <figure class="pb-8 max-w-[800px] mx-auto at768:pb-12">
                    <blockquote class="leading-[1.2]">
                        “I wanted to thank you for helping me with all my
                        locking and hardware needs over many years! Your
                        friendly, level-headed knowledge in your products and
                        usage is AWESOME!”
                    </blockquote>
                    <figcaption
                        class="font-bold mt-[30px] text-gray-800 text-base"
                    >
                        Jim W.
                    </figcaption>
                </figure>
            </SplideSlide>
            <SplideSlide>
                <figure class="pb-8 max-w-[800px] mx-auto at768:pb-12">
                    <blockquote class="leading-[1.2]">
                        “SECLOCK saved the day. You sent a quote within minutes
                        of my request.”
                    </blockquote>
                    <figcaption
                        class="font-bold mt-[30px] text-gray-800 text-base"
                    >
                        John P.
                    </figcaption>
                </figure>
            </SplideSlide>
            <SplideSlide>
                <figure class="pb-8 max-w-[800px] mx-auto at768:pb-12">
                    <blockquote class="leading-[1.2]">
                        “I tell everyone – when no one else has it, chances are
                        SECLOCK does. The combinations you all can build is
                        pretty amazing.”
                    </blockquote>
                    <figcaption
                        class="font-bold mt-[30px] text-gray-800 text-base"
                    >
                        Christina B.
                    </figcaption>
                </figure>
            </SplideSlide>
        </Splide>
    </section>
    <section class="bg-gradient-to-b from-black to-gray-800">
        <div
            class="bg-shape-paths-black bg-cover bg-top px-4 py-[90px] text-center text-white at1024:gap-12 at1024:grid at1024:grid-cols-2 at1024:max-w-[1124px] at1024:mx-auto at1024:pb-[216px] at1024:pt-[180px] at1024:px-8 at1024:text-left"
        >
            <h2 class="font-bold mb-5 text-2xl at1024:mb-0 at1024:text-5xl">
                See the SECLOCK difference, and join us on the path.
            </h2>
            <div>
                <p
                    class="leading-[1.2] mb-[30px] text-lg at1024:pt-6 at1024:text-[23px]"
                >
                    Our unmatched in-stock inventory, immediate same-day
                    shipping, and technical expertise mean you will find the
                    perfect solution for every project with SECLOCK.
                </p>
                <a href="/register" class="btn-blue-on-gray"
                >Register now</a
                >
            </div>
        </div>
    </section>
</template>

<script>
import { BaseSvg } from "@/Components";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";

export default {
    name: "page-landing-locksmiths",
    components: { BaseSvg, SplideSlide, Splide, SplideTrack },
    // mounted() {}
};
</script>
